var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1027 14.6856V7.11606C13.1027 6.64467 12.9613 6.47955 12.4895 6.47955H8.62238C8.15038 6.47955 8.00899 6.64475 8.00899 7.11606V8.74304C8.00899 9.21489 8.15038 9.37993 8.62238 9.37993H9.73044V12.6813C9.58897 12.7046 9.11712 12.7278 8.57492 12.7278C5.36865 12.7278 4.54253 10.6532 4.54253 7.80018C4.54253 4.19189 5.9107 3.27192 8.8815 3.27192C9.77782 3.27192 10.98 3.34311 11.6643 3.38973C12.2768 3.43711 12.442 3.36638 12.5369 2.84753L12.8198 1.1499C12.8902 0.678127 12.796 0.466312 12.3005 0.418854C12.1352 0.395125 11.0747 0.253662 8.64603 0.253662C3.10402 0.253662 0.864258 3.10673 0.864258 7.8001C0.864258 12.4449 2.70351 15.7461 8.43338 15.7461C11.0036 15.7461 11.971 15.6284 12.4657 15.5106C12.9613 15.3929 13.1027 15.204 13.1027 14.6856Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIcon);
export default __webpack_public_path__ + "static/media/gIcon.4aa0f8eb.svg";
export { ForwardRef as ReactComponent };